module.exports = __webpack_public_path__ + "img/NenhumaAulaAgendada.483d1d64.png";